export const memberColumns = [
  { id: 'connection', label: 'Member', sortable: false },
  { id: 'actions', label: '', sortable: false },
];
